import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { MemberEditRequestBody, MemberEditResponse } from "./types";

export class MemberEditAPI extends BaseAPI<
    MemberEditRequestBody,
    MemberEditResponse
> {
    protected route = ApiRoutes.member.edit;
    protected method = RequestMethod.PUT;
    protected params = ["id"]
}
